import { Tabs } from "antd";
import React, { useCallback, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useUserManagementTabs from "../../lib/hooks/useUserManagementTabs";
import WithSidebar from "../../templates/withSidebar";
import Role from "./role";
import SearchRoleProvider from "./role/searchContext";
import User from "./user";
import SearchUserProvider from "./user/searchContext";
import Staff from "./staff";
import SearchStaffProvider from "./staff/searchContext";
import Report from "./report";
import SearchReportProvider from "./report/searchContext";

const UserManagement = () => {
  const navigate = useNavigate();
  const { tabs, setTabs } = useUserManagementTabs();
  const [searchParams] = useSearchParams();
  const currentMenu = searchParams.get("management");
  const currentTab = searchParams.get("tab");

  const setChangeTabfromState = useCallback(
    (tab) => {
      setTabs(tab);
    },
    [setTabs]
  );

  useEffect(() => {
    setChangeTabfromState(currentTab);
  }, [currentMenu, currentTab]);

  const onChangeTab = (key) => {
    setTabs(key);
    navigate({
      pathname: `/user-management`,
      search: `?menu=management&tab=${key}`,
    });
  };

  const items = [
    {
      key: "user",
      label: <strong>การจัดการผู้ใช้งาน</strong>,
      children: (
        <SearchUserProvider>
          <User />
        </SearchUserProvider>
      ),
    },
    {
      key: "role",
      label: <strong>การจัดการบทบาทและสิทธิ์การเข้าถึง</strong>,
      children: (
        <SearchRoleProvider>
          <Role />
        </SearchRoleProvider>
      ),
    },
    {
      key: "staff",
      label: <strong>การจัดการรายชื่อเจ้าหน้าที่จัดทำรายงาน</strong>,
      children: (
        <SearchStaffProvider>
          <Staff />
        </SearchStaffProvider>
      ),
    },
    {
      key: "reportlogin",
      label: <strong>รายงานการเข้าใช้ระบบ</strong>,
      children: (
        <SearchReportProvider>
          <Report />
        </SearchReportProvider>
      ),
    },
  ];

  return (
    <WithSidebar>
      <Tabs activeKey={tabs} items={items} onChange={onChangeTab} />
    </WithSidebar>
  );
};

export default UserManagement;
